var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y2: "99.258%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aabee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ed9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    fill: "url(#a)",
    r: 500
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.328 494.722l291.59-125.6c138.856-57.755 167.708-67.787 186.514-68.118 4.137-.073 13.385.952 19.375 5.813 5.06 4.104 6.45 9.65 7.117 13.54s1.495 12.757.836 19.684c-7.525 79.06-40.084 270.924-56.648 359.474-7.01 37.47-20.8 50.033-34.17 51.262-29.036 2.672-51.085-19.19-79.208-37.624L450.15 638.2c-49.366-32.53-17.364-50.41 10.77-79.63 7.362-7.65 135.295-124.014 137.77-134.57.3-1.32.597-6.24-2.326-8.84s-7.24-1.7-10.353-1.003c-4.413 1.002-74.714 47.468-210.902 139.4-19.955 13.703-38.03 20.38-54.223 20.03-17.853-.386-52.194-10.094-77.723-18.393-31.313-10.178-56.2-15.56-54.032-32.846 1.128-9.003 13.527-18.21 37.196-27.624z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.115072899431912f46bbd4363308eaa4.svg";
export { ForwardRef as ReactComponent };